<template>
  <div class="custom-menu-tree">
    <template v-for="item in dataList">
      <el-menu-item class="" v-if="!item.children.length" :key="item.permissionsModelId" :index="item.path">
        <!-- <i :class="[item.meta.icon ? item.meta.icon : '']"></i> -->
        <span>{{ item.permissionsModelName }}</span>
      </el-menu-item>
      <el-submenu v-else :key="item.permissionsModelId" :index="item.permissionsModelName">
          <template slot="title">
            <!-- <i :class="[item.meta.icon ? item.meta.icon : '']"></i> -->
            <span>{{ item.permissionsModelName }}</span>
          </template>
          <MenuTree :dataList="item.children||[]"></MenuTree>
        </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
    name: 'MenuTree',  // 很重要，调用自身需要用到
    props: ['dataList'],
    data() {
        return {
          
        }
    },
    mounted() {
        
    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
	/deep/.el-menu-item{
		text-align: left;
	}
	/deep/.el-submenu{
		text-align: left;
		height: auto!important;
	}
</style>

